"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var react_1 = __importStar(require("react"));
var styles = __importStar(require("./OnboardingBannerPanel.css"));
var PanelInner = (0, react_1.forwardRef)(function (_a, ref) {
    var title = _a.title, description = _a.description, onDismiss = _a.onDismiss, actionCards = _a.actionCards;
    return (react_1.default.createElement("div", { ref: ref },
        react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Close, null), size: kaleidoscope_1.ButtonSize.Small, className: styles.closeButton, onClick: function () { return onDismiss(); } }),
        react_1.default.createElement("div", { className: styles.content },
            react_1.default.createElement(kaleidoscope_1.Heading, { level: "3", strong: true }, title),
            react_1.default.createElement(kaleidoscope_1.Text, { secondary: true, size: "s" }, description),
            react_1.default.createElement("div", { className: styles.actionCards }, actionCards))));
});
var OnboardingBannerPanel = function (_a) {
    var show = _a.show, props = __rest(_a, ["show"]);
    return (react_1.default.createElement(kaleidoscope_1.Expandable, { expanded: show, timeout: kaleidoscope_2.AnimationDuration.Long, element: kaleidoscope_1.Card, className: styles.onboardingBannerPanel }, function (_a) {
        var expandableElementRef = _a.expandableElementRef;
        return react_1.default.createElement(PanelInner, __assign({ ref: expandableElementRef }, props));
    }));
};
exports.default = OnboardingBannerPanel;
